import React, {useState, useCallback} from 'react';
import styles from './styles';
import moment from 'moment';
import {Button, ModalContainer, Icons} from '@xpertdox_js/xdcomponents';

const LogsComponent = (props) => {
  const [toggleQc, setToggleQc] = useState(false)
  const [toggleOvr, setToggleOvr] = useState(false)

  const [currentHeight, setCurrentHeight] = useState(null);
  const measureHeight = useCallback(elem => {
    if (elem && elem.clientHeight !== currentHeight) {
      setCurrentHeight(elem.clientHeight);
    }
  })

  const LogsList = (list, title, type) => {
    let logsAction = (log) => {
      if(type === 'qc') return log.action ? 'QC: Yes' : 'QC: No'
      else if(type === 'main') return log.type
    };
    let logsTime = (log) => {
      if(type === 'main') return moment(log.created_date).format('lll');
      else if(type === 'qc') return log.timestamp
    }
    let logToggle = (set) => {
      if(type === 'main') setToggleOvr(set)
      else if(type === 'qc') setToggleQc(set)
    }
    if(type==='qc') list.reverse();
    return <React.Fragment>
      <Button onClick={() => logToggle(type === 'qc' ? !toggleQc : !toggleOvr)} styles={styles.headerToggle}>{title} <Icons style={styles.icon} icon='infoSolid'/></Button>
      <ModalContainer
        open={type === 'qc' ? toggleQc : toggleOvr}
        showOverlay={type === 'qc' ? toggleQc : toggleOvr}
        close={() => logToggle(false)}
        width='550px'
        height='250px'
      >
        <div style={{...styles.logContainer, height: 249}}>
          {list.map((log, i) => <div key={i} style={styles.logEntry}>
            <strong>{logsAction(log)}</strong> {log.email}<br/>
            <i>{logsTime(log)}</i>
          </div>)}
        </div>
      </ModalContainer>
    </React.Fragment>
  }


  return <div style={styles.container} ref={measureHeight}>
    {(props.approvedLogs && props.approvedLogs.length > 0) && LogsList(props.approvedLogs, 'QC Logs', 'qc')}
    {props.data && LogsList(props.data, 'Overview Logs', 'main')}
  </div>
}

export default LogsComponent;
